// extracted by mini-css-extract-plugin
module.exports = {"link":"ApplyLink_link__5mpNG"};